var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 56,
    viewBox: "0 0 53 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.0424 22.4497H49.9319V22.3341H26.3502V33.4748H41.1582C38.9978 39.96 33.1928 44.6155 26.3502 44.6155C17.6683 44.6155 10.6292 37.1331 10.6292 27.9044C10.6292 18.6758 17.6683 11.1934 26.3502 11.1934C30.3578 11.1934 34.0038 12.8005 36.7799 15.4255L44.191 7.54763C39.5114 2.91171 33.2518 0.0527344 26.3502 0.0527344C11.8803 0.0527344 0.148438 12.5233 0.148438 27.9044C0.148438 43.2855 11.8803 55.7561 26.3502 55.7561C40.8202 55.7561 52.552 43.2855 52.552 27.9044C52.552 26.037 52.3712 24.2141 52.0424 22.4497Z",
    fill: "#FFC107"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3496 55.755C33.1175 55.755 39.2671 53.0018 43.9166 48.5247L35.8071 41.2303C33.0881 43.4284 29.7656 44.6172 26.3496 44.6143C19.5345 44.6143 13.7478 39.9951 11.5678 33.5488L3.02344 40.5466C7.35984 49.5663 16.1663 55.755 26.3496 55.755Z",
    fill: "#4CAF50"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M52.0418 22.4505H49.9312V22.335H26.3496V33.4756H41.1576C40.1242 36.5622 38.2627 39.2593 35.8032 41.2337L35.8071 41.2309L43.9166 48.5253C43.3428 49.0796 52.5514 41.8311 52.5514 27.9053C52.5514 26.0378 52.3706 24.215 52.0418 22.4505Z",
    fill: "#1976D2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.16992 14.9409L11.7785 21.6517C14.1079 15.5216 19.7491 11.1934 26.3507 11.1934C30.3582 11.1934 34.0042 12.8005 36.7803 15.4255L44.1915 7.54763C39.5118 2.91171 33.2522 0.0527344 26.3507 0.0527344C16.2865 0.0527344 7.55872 6.09237 3.16992 14.9409Z",
    fill: "#FF3D00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleIcon);
export default __webpack_public_path__ + "static/media/googleIcon.488543acca1519f946550a4c4ded8eb9.svg";
export { ForwardRef as ReactComponent };